import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import sentGAEvent from '@/ga';
import moment from 'moment';
import Utils from '@/utils';
import TipsModal from '@/components/common/exceed20Modal/TipsModal';
// import TipsModal from '@/components/common/tipModal/TipsModal'
import FixMessage from '@/components/fixedMessage/fixedMessage';
import TipSimpleModal from '@/components/common/tipSimpleModal/TipSimpleModal';
import { withTranslation } from 'react-i18next';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import AddFileByDragFunction from './children/AddFileByDragFunction';
import CropPic from './children/cropPic/CropPic';
import Process from '@/components/common/process/Process';
import actions from '../../../../redux/action';
import { getImgWidthHeight } from '@/utils/common';

class AddFileByDrag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warningInfo: false,
      warningInfoText: '',
      warningInfoObj: {},
      startTime: 0,
      messageShow: false,
      messageText: '',
    };
  }

  handlePurchaseModalObjChange = (purchaseModalObj) => {
    console.log(purchaseModalObj);
    this.props.onPurchaseModalObjChange(purchaseModalObj);
  };

  fileToBlob = async (file, guid, recordVideo) => {
    let blob;
    try {
      blob = new Blob([file], { type: file.type });
    } catch (err) {
      console.log('Turn Blob Error: ', err);
      if (this.props.work === 'audioCut') {
        sentGAEvent({
          category: 'audio_cut_add_files',
          action: 'audio_cut_add_failed',
        });
      } else if (this.props.work === 'audioVolume') {
        sentGAEvent({
          category: 'audio_volume_add_files',
          action: 'audio_volume_add_failed',
        });
      } else if (this.props.work === 'audioSpeed') {
        sentGAEvent({
          category: 'audio_speed_add_files',
          action: 'audio_speed_add_failed',
        });
      }

      return false;
    }
    const blobUrl = URL.createObjectURL(blob);
    let blobDuration;
    let duration;
    let screenshots = [];
    let thumbnail;

    if (
      file.type.indexOf('video') !== -1 ||
      file.type.indexOf('audio') !== -1 ||
      file.type.indexOf('application/x-shockwave-flash') !== -1
    ) {
      try {
        blobDuration = await Utils.getBlobDuration(blobUrl);
        if (
          file.type.indexOf('video') !== -1 ||
          file.type === 'application/x-shockwave-flash'
        ) {
          await Utils.isVideoBlobURLLoadedSuccess(blobUrl);
        }
      } catch (error) {
        console.log('blobDuration Err:', error);
        return false;
      }
      duration = moment('00:00.00', 'mm:ss.SS')
        .add(blobDuration.toFixed(2), 'seconds')
        .format('mm:ss.SS');
      //screenshots
      const shot = blobDuration / 7;
      for (let i = 0; i < 7; i++) {
        screenshots.push(blobUrl + '#t=' + i * shot);
      }
      thumbnail = blobUrl + '#t=0';
    }
    if (this.props.work === 'audioJoiner') {
      sentGAEvent({
        category: 'audio_merge_add_files',
        action: 'audio_merge_add_files_num',
        label:
          /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
          '_' +
          Utils.changeTimeToGAString(blobDuration) +
          '_' +
          (file.size / 1024 / 1024).toFixed(2),
      });
    } else if (this.props.work === 'audioCut') {
      sentGAEvent({
        category: 'audio_cut_add_files',
        action: 'audio_cut_add_files_click',
        label:
          /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
          '_' +
          (file.size / 1024 / 1024).toFixed(2) +
          '_' +
          Utils.changeTimeToGAString(blobDuration),
      });
    } else if (this.props.work === 'audioVolume') {
      sentGAEvent({
        category: 'audio_volume_add_files',
        action: 'audio_volume_add_files_click',
        label:
          /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
          '_' +
          (file.size / 1024 / 1024).toFixed(2) +
          '_' +
          Utils.changeTimeToGAString(blobDuration),
      });
    } else if (this.props.work === 'audioSpeed') {
      sentGAEvent({
        category: 'audio_speed_add_files',
        action: 'audio_speed_add_files_click',
        label:
          /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
          '_' +
          (file.size / 1024 / 1024).toFixed(2) +
          '_' +
          Utils.changeTimeToGAString(blobDuration),
      });
    } else if (this.props.work === 'audioAddMusic') {
      sentGAEvent({
        category: 'add_music_add_files',
        action: 'add_music_add_files_click',
        label:
          /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
          '_' +
          (file.size / 1024 / 1024).toFixed(2) +
          '_' +
          Utils.changeTimeToGAString(blobDuration),
      });
    }
    const arrItem = {
      name: file.name,
      guid: guid || new Date().getTime(),
      duration: duration,
      size: file.size,
      thumbnail: thumbnail,
      status: 'ready',
      videofileurl: blobUrl,
      screenshots: screenshots,
      mark: false,
      uploadStatus: false,
      uploadTimes: 0,
      fileObj: file,
      recordVideo,
      type: file.type,
    };
    if (this.props.addFileCallBack) {
      this.props.addFileCallBack(arrItem);
      return true;
    }
    const files = [...this.props.files];
    console.log('fileblob7777', file);

    files.push(arrItem);
    // localStorage.setItem("files", JSON.stringify(files));
    if (this.props.isCropPreload) {
      this.props.onCropChange({ visible: true });
    }
    this.props.onFilesChange(files);
    this.props.onCurrFileChange({ ...arrItem });
    return true;
  };

  upload = async (file, fileExiting, recordVideo, guid) => {
    this.props.onFileToBlobStatusChange(false);
    this.props.onUploadPercentChange(0);
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(this.props.processStep + 3);
    const startTime = { ...this.props.startTime };
    startTime.upload = new Date().getTime();
    this.props.onStartTimeChange(startTime);

    this.setState({ file: file });
    // V1.2.0: 先将视频转为Blob，转换失败再出现进度条
    guid = guid || new Date().getTime();
    let fileToBlobResponse;

    //当没有isShowUploadProcess，说明需要后台上传文件，否则直接展示进度条
    if (!this.props.isShowUploadProcess) {
      // 上传的文件已经存在列表中
      if (!fileExiting) {
        fileToBlobResponse = await this.fileToBlob(file, guid, recordVideo);
        if (fileToBlobResponse) {
          this.props.onFileToBlobStatusChange(true);
        }
      } else if (this.props.uploadAgainFile) {
        guid = this.props.uploadAgainFile.guid;
      }
    }

    // V1.1.0版本：一开始就需要出现进度条
    this.props.onUploadingChange(true);
    const newFileName = file.name.replace(
      /\(|\)|\s+|\uff08|\uff09|\u3010|\u3011|\$|#/g,
      '-'
    );
    file = new File([file], newFileName, { type: file.type });
    // upload and converit to mp4
    let fileResponse, apiUrl;
    try {
      if (
        file.type.indexOf('video') !== -1 ||
        file.type === 'application/x-shockwave-flash'
      ) {
        fileResponse = await this.requestUploadVideoFile(file);
        apiUrl = 'uploadVideo';
      } else if (file.type.indexOf('audio') !== -1) {
        fileResponse = await this.requestUploadAudioFile(file);
        apiUrl = 'uploadAudio';
      } else {
        fileResponse = await this.requestUploadImageFile(file);
        apiUrl = 'uploadImage';
      }
    } catch (error) {
      if (error !== 'cancel') {
        if (!this.props.fileToBlobStatus) {
          if (
            this.props.work === 'addLipShape' ||
            this.props.work === 'dynamicPhoto'
          ) {
            message.warn(
              this.props.submitting
                ? this.props.t(
                    'Processing failed. Get HitPaw Toolkit for stable processing.'
                  )
                : this.props.t(
                    'Failed to load!  Get HitPaw Watermark Remover for stable processing.'
                  )
            );
          } else {
            this.setState({ uploadFail: true });
          }
        }

        if (this.props.work === 'dynamicPhoto') {
          getImgWidthHeight(window.URL.createObjectURL(file)).then((res) => {
            this.setState({ startTime: new Date().getTime() });

            const { width, height } = res;
            sentGAEvent({
              category: 'Upload',
              action: 'AnimateOld_UploadFail',
              label: `${file.name.substring(file.name.lastIndexOf('.') + 1)}_${(
                file.size /
                1024 /
                1024
              ).toFixed(2)}m`,
            });
          });
          this.props.t('Error Network');
        } else {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label:
              error + '_none_none_' + this.props.tokenId + '_none_none_none',
          });
        }
      }
      this.props.onUploadingChange(false);
      this.props.onUploadPercentChange(0);
      this.props.onProcessPercentChange(0);
      return false;
    }
    if (fileResponse.code === 200) {
      let progressResponse;
      if (fileResponse.data.result.number) {
        // get videofileurl
        const fileResponseNumber = fileResponse.data.result.number;
        console.log(fileResponseNumber);
        try {
          if (this.props.work === 'togif') {
            sentGAEvent({
              category: 'UploadStart',
              action: '37TG_UploadStart',
            });
          }
          progressResponse = await Utils.getProgress(fileResponseNumber, false);
        } catch (error) {
          if (error !== 'cancel') {
            if (!this.props.fileToBlobStatus) {
              if (
                this.props.work === 'addLipShape' ||
                this.props.work === 'dynamicPhoto'
              ) {
                message.warn(
                  this.props.submitting
                    ? this.props.t(
                        'Processing failed. Get HitPaw Toolkit for stable processing.'
                      )
                    : this.props.t(
                        'Failed to load!  Get HitPaw Watermark Remover for stable processing.'
                      )
                );
              } else {
                this.setState({ uploadFail: true });
              }
            }
            if (this.props.work === 'dynamicPhoto') {
              getImgWidthHeight(window.URL.createObjectURL(file)).then(
                (res) => {
                  this.setState({ startTime: new Date().getTime() });

                  const { width, height } = res;
                  sentGAEvent({
                    category: 'Upload',
                    action: 'AnimateOld_UploadFail',
                    label: `${file.name.substring(
                      file.name.lastIndexOf('.') + 1
                    )}_${(file.size / 1024 / 1024).toFixed(2)}m`,
                  });
                }
              );
            } else {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: apiUrl + '_200_200_' + error,
              });
            }
          }
          this.props.onUploadingChange(false);
          this.props.onUploadPercentChange(0);
          this.props.onProcessPercentChange(0);
          return false;
        }
        console.log('progressResponse', progressResponse);
        if (this.props.work === 'togif') {
          sentGAEvent({
            category: 'UploadSuccess',
            action: '37TG_UploadSuccess',
          });
        }
      } else {
        this.props.onProcessPercentChange(this.props.processPercent + 100);
      }
      const videofileurl = fileResponse.data.response_file[0];
      const fps = progressResponse.info[0].fps;
      let wh;
      try {
        wh = progressResponse.info[0].wh.match(/^\d+x\d+/)[0];
      } catch (e) {
        wh = '0x0';
      }
      let duration, screenshots, thumbnail;
      if (
        file.type.indexOf('video') !== -1 ||
        file.type.indexOf('audio') !== -1 ||
        file.type === 'application/x-shockwave-flash'
      ) {
        duration = moment('00:00:00', 'mm:ss:SS')
          .add(parseFloat(progressResponse.info[0].duration), 'seconds')
          .format('mm:ss:SS')
          .replace(/:([^:]*)$/, '.$1');
        // get screenshots
        const d = Utils.getSeconds(duration);
        if (d < 1) {
          this.setState({
            warningInfo: true,
            warningInfoText:
              'The minimum time length is 1s! Get HitPaw Toolkit for more features.',
            warningInfoObj: { type: 'duration', duration: d },
          });
          this.props.onUploadingChange(false);
          const newFiles = this.props.files.filter(
            (item) => item.guid !== guid
          );
          this.props.onCurrFileChange(null);
          this.props.onFilesChange(newFiles);
          return false;
        }

        screenshots = progressResponse.thumbnail[0].img;
        thumbnail = screenshots[0];
      }
      const files = [...this.props.files];

      // thumbnail V1.1.0 版本，获取所有视频信息后才设置文件信息
      if (!this.props.fileToBlobStatus && !fileToBlobResponse && !fileExiting) {
        const arrItem = {
          name: file.name,
          guid: guid,
          duration: duration,
          size: file.size,
          thumbnail: thumbnail,
          status: 'origin',
          videofileurl: videofileurl,
          screenshots: screenshots,
          mark: false,
          wh: wh,
          fps: fps,
          uploadStatus: true,
          recordVideo: null,
          type: file.type,
        };
        files.push(arrItem);
        // this.props.onCurrFileChange(arrItem)
        if (!this.props.currFile) {
          this.props.onCurrFileChange(arrItem);
        }
      } else {
        files.forEach((item) => {
          if (item.guid === guid) {
            item.duration = duration;
            item.thumbnail = thumbnail;
            item.screenshots = screenshots;
            item.videofileurl = videofileurl;
            item.wh = wh;
            item.fps = fps;
            item.uploadStatus = true;
            item.recordVideo = null;
            this.props.onCurrFileChange({ ...item });
          }
        });
      }
      if (!this.props.submitting) {
        this.props.onProcessPercentChange(0);
        this.props.onUploadPercentChange(0);
      }
      this.props.onUploadingChange(false);
      this.props.onFilesChange(files);
      // localStorage.setItem("files", JSON.stringify(files));
      this.props.onPreUploadFileChange(null);
      message.destroy();

      if (this.props.work === 'dynamicPhoto') {
        getImgWidthHeight(window.URL.createObjectURL(file)).then((res) => {
          const { width, height } = res;
          const endTime = new Date().getTime();
          const time = (endTime - this.state.startTime) / 1000;
          sentGAEvent({
            category: 'Upload',
            action: 'AnimateOld_UploadSuccess',
            label: `${file.name.substring(file.name.lastIndexOf('.') + 1)}_${(
              file.size /
              1024 /
              1024
            ).toFixed(2)}m_${width}*${height}_${time}s`,
          });
          sentGAEvent({
            category: 'UploadSuccess',
            action: '22AO_UploadSuccess',
            label: `Null`,
          });
        });
      } else if (this.props.work === 'addLipShape') {
        sentGAEvent({
          category: 'UploadSuccess',
          action: '23FA_UploadSuccess',
          label: `Null`,
        });
      } else {
        console.log('this.props.work', this.props.work);
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerSuccess',
        });
      }
      if (
        this.props.uploadHasEmailCallback &&
        fileResponse.data.email &&
        fileResponse.data.email_verify_status === 1
      ) {
        this.props.uploadHasEmailCallback(
          fileResponse.data.email,
          fileResponse.data.eta_minutes
        );
        if (this.props.work === 'addLipShape') {
          sentGAEvent({
            category: 'FaceAnimator',
            action: 'FaceEmail',
            label: '1',
          });
        } else if (this.props.work === 'dynamicPhoto') {
          sentGAEvent({
            category: 'AnimateOld',
            action: 'OldEmail',
            label: '1',
          });
        }
      } else if (
        (this.props.uploadHasEmailCallback && !fileResponse.data.email) ||
        fileResponse.data.email_verify_status !== 1
      ) {
        if (this.props.work === 'addLipShape') {
          sentGAEvent({
            category: 'FaceAnimator',
            action: 'FaceEmail',
            label: '0',
          });
        } else if (this.props.work === 'dynamicPhoto') {
          this.props.uploadHasEmailCallback();
          sentGAEvent({
            category: 'AnimateOld',
            action: 'OldEmail',
            label: '0',
          });
        }
      }
    } else {
      console.log('我进入了333333333');
      if (fileResponse.code === 401) {
        Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
        let hostName = window.location.hostname;
        Cookies.remove('access_token', {
          domain: hostName.substring(
            window.location.hostname.indexOf('.'),
            hostName.length
          ),
        });
        Cookies.remove('access_token_expires_in', {
          domain: hostName.substring(hostName.indexOf('.'), hostName.length),
        });
        window.location.replace(
          `${accountList.get('login')}?redirect=${window.location.href}`
        );
      }
      if (!this.props.fileToBlobStatus) {
        if (
          this.props.work === 'addLipShape' ||
          this.props.work === 'dynamicPhoto'
        ) {
          message.warn(
            this.props.submitting
              ? this.props.t(
                  'Processing failed. Get HitPaw Toolkit for stable processing.'
                )
              : this.props.t(
                  'Failed to load!  Get HitPaw Watermark Remover for stable processing.'
                )
          );
        } else {
          this.setState({ uploadFail: true });
        }
      }
      this.props.onUploadingChange(false);
      this.props.onUploadPercentChange(0);
      this.props.onProcessPercentChange(0);
      if (this.props.work === 'dynamicPhoto') {
        getImgWidthHeight(window.URL.createObjectURL(file)).then((res) => {
          this.setState({ startTime: new Date().getTime() });

          const { width, height } = res;
          sentGAEvent({
            category: 'Upload',
            action: 'AnimateOld_UploadFail',
            label: `${file.name.substring(file.name.lastIndexOf('.') + 1)}_${(
              file.size /
              1024 /
              1024
            ).toFixed(2)}m`,
          });
        });
      } else {
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            apiUrl +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
      }
    }
  };

  requestUploadVideoFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadVideo`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.props.onUploadPercentChange(
            parseInt((event.loaded / event.total) * 100)
          );
        }
      };
      xhr.onerror = () => {
        reject('uploadVideo_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  requestUploadAudioFile = (file) => {
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadAudio`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.props.onUploadPercentChange(
            parseInt((event.loaded / event.total) * 100)
          );
        }
      };
      xhr.onerror = () => {
        reject('uploadAudio_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  requestUploadImageFile = (file) => {
    if (this.props.work === 'dynamicPhoto') {
      getImgWidthHeight(window.URL.createObjectURL(file)).then((res) => {
        this.setState({ startTime: new Date().getTime() });

        const { width, height } = res;
        sentGAEvent({
          category: 'Upload',
          action: 'AnimateOld_UploadStart',
          label: `${file.name.substring(file.name.lastIndexOf('.') + 1)}_${(
            file.size /
            1024 /
            1024
          ).toFixed(2)}m_${width}*${height}`,
        });

        sentGAEvent({
          category: 'UploadStart',
          action: '22AO_UploadStart',
          label: 'Null',
        });
      });
    } else if (this.props.work === 'addLipShape') {
      sentGAEvent({
        category: 'UploadStart',
        action: '23FA_UploadStart',
        label: `Null`,
      });
    } else {
      sentGAEvent({
        category: 'Upload',
        action: 'LocalSerStart',
      });
    }
    const formData = new FormData();
    formData.append('files[]', file);
    formData.append('token', this.props.tokenId);
    if (this.props.crop) {
      const actions = [];
      const crop = {
        type: 'crop',
        x: this.props.crop.x,
        y: this.props.crop.y,
        w: this.props.crop.width,
        h: this.props.crop.height,
      };
      actions.push(crop);
      formData.append('add_action[]', JSON.stringify({ actions: actions }));
    }
    this.props.onUploadPercentChange(1);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/uploadImage`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.props.onUploadPercentChange(
            parseInt((event.loaded / event.total) * 100)
          );
        }
      };
      xhr.onerror = () => {
        reject('uploadImage_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };

  handleUpload = async (file) => {
    this.setState({ file });
    if (this.props.isUploadPreload) {
      this.upload(file);
    } else if (this.props.isCropPreload || this.props.isPreloadBlob) {
      await this.fileToBlob(file);
    } else {
      const files = [...this.props.files];
      const newFile = {
        name: file.name,
        guid: new Date().getTime(),
        size: file.size,
        status: 'ready',
        uploadStatus: false,
        fileObj: file,
        type: file.type,
      };
      if (this.props.work === 'convert') {
        newFile.convertType =
          file.type.indexOf('video') !== -1
            ? 'mp4'
            : file.type.indexOf('audio') !== -1
            ? 'mp3'
            : file.type.indexOf('image') !== -1
            ? 'jpg'
            : this.props.type === 'video'
            ? 'mp4'
            : this.props.type === 'audio'
            ? 'mp3'
            : 'jpg';
        newFile.convertFileType =
          file.type.indexOf('video') !== -1
            ? 'video'
            : file.type.indexOf('audio') !== -1
            ? 'audio'
            : file.type.indexOf('image') !== -1
            ? 'image'
            : this.props.type;
        newFile.fileType =
          file.type.indexOf('video') !== -1
            ? 'video'
            : file.type.indexOf('audio') !== -1
            ? 'audio'
            : file.type.indexOf('image') !== -1
            ? 'image'
            : this.props.type;
      }
      if (this.props.addFileCallBack) {
        this.props.addFileCallBack(newFile);
      }

      files.push(newFile);
      this.props.onFilesChange(files);
    }
  };

  handleCropSubmit = () => {
    this.upload(this.state.file, true, false, this.props.currFile.guid);
  };

  // cancelUpload = () => {
  //   const xhr = this.state.uploadXHR;
  //   if (xhr && this.props.uploadPercent < 100) {
  //     xhr.abort();
  //   } else {
  //     Utils.cancleProgress();
  //   }
  //   this.props.onUploadingChange(false);
  //   this.props.onUploadPercentChange(0);
  //   this.props.onProcessPercentChange(0);
  // };

  handleWarningObj = ({ warningInfo, warningInfoText, warningInfoObj }) => {
    this.setState({
      warningInfo,
      warningInfoText,
      warningInfoObj,
    });
  };
  handleFixedMessageChange = ({ messageShow, messageText }) => {
    this.setState({
      messageShow,
      messageText,
    });
  };
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('blob')) {
      try {
        fetch(urlParams.get('blob'))
          .then((response) => response.blob())
          .then((responseBLOB) => {
            const file = new File(
              [responseBLOB],
              urlParams.has('type') ? 'VideoFromOnline' : 'videoFromRecorder',
              {
                type: 'video/mp4',
              }
            );
            this.upload(file, false, true);
            // window.history.replaceState({}, document.title, window.location.pathname)
            window.history.replaceState(
              {},
              document.title,
              'https://www.hitpaw.com/video-to-gif-online.html'
            );
          });
      } catch (e) {
        console.log(e);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.preUploadFile !== this.props.preUploadFile &&
      this.props.preUploadFile
    ) {
      if (!this.props.submitting) {
        this.upload(this.props.preUploadFile);
      } else {
        this.upload(this.props.preUploadFile, true);
      }
    }
  }

  render() {
    return (
      <div>
        <FixMessage
          visible={this.state.messageShow}
          onCancel={() => {
            this.setState({ messageShow: false });
          }}
          content={this.state.messageText}
        />
        <AddFileByDragFunction
          handleWarningObj={this.handleWarningObj}
          handleFixedMessageChange={this.handleFixedMessageChange}
          hideCancelText={this.props.hideCancelText}
          upload={this.handleUpload}
          files={this.props.files}
          accept={this.props.accept}
          size={this.props.size}
          uploadBtnText={this.props.uploadBtnText}
          work={this.props.work}
          uploadNoteText={this.props.uploadNoteText}
          theme={this.props.theme}
          uploadMaxCount={this.props.uploadMaxCount}
          handlePurchaseModalObjChange={this.handlePurchaseModalObjChange}
          advertiseConfig={this.props.advertiseConfig}
          openAdvertiseDialog={this.props.openAdvertiseDialog}
          onExceed2M={this.props.onExceed2M}
          subscription={this.props.subscription}
        />

        <CropPic
          handleCropSubmit={this.handleCropSubmit}
          work={this.props.work}
        />
        {!this.props.isHideUploadProcessCont ? (
          <Process
            hideCancelText={this.props.hideCancelText}
            showProcessText={this.props.showProcessText}
            theme={this.props.theme ? this.props.theme : 'dark'}
            border={this.props.size === 'thin' ? 'dashed' : null}
          />
        ) : null}
        {this.props.work.indexOf('audio') !== -1 ? (
          <>
            <TipSimpleModal
              visible={this.state.uploadFail}
              onCancel={() => {
                this.setState({ uploadFail: false });
              }}
              content={
                this.props.submitting
                  ? 'Processing failed. Get HitPaw Toolkit for stable processing.'
                  : 'Failed to load!  Get HitPaw Watermark Remover for stable processing.'
              }
              cancelBtnHandle={this.cancelTryAgain}
              confirmBtnHandle={this.uploadAgain}
              confirmBtnText='Try Again'
              productKey={
                this.props.work === 'removeWatermark'
                  ? 'hitpaw-watermark-remover'
                  : undefined
              }
            />
            <TipSimpleModal
              visible={this.state.warningInfo}
              onCancel={() => {
                this.setState({ warningInfo: false });
              }}
              content={this.state.warningInfoText}
              tipsObj={this.state.warningInfoObj}
              cancelBtnHandle={() => {
                this.setState({ warningInfo: false });
              }}
              hasDownload
            />
          </>
        ) : (
          <>
            <TipsModal
              visible={this.state.uploadFail}
              onCancel={() => {
                this.setState({ uploadFail: false });
              }}
              content={
                this.props.submitting
                  ? 'Processing failed. Get HitPaw Toolkit for stable processing.'
                  : 'Failed to load!  Get HitPaw Watermark Remover for stable processing.'
              }
              cancelBtnHandle={this.cancelTryAgain}
              confirmBtnHandle={this.uploadAgain}
              confirmBtnText='Try Again'
              productKey={
                this.props.work === 'removeWatermark'
                  ? 'hitpaw-watermark-remover'
                  : undefined
              }
            />
            <TipsModal
              visible={this.state.warningInfo}
              onCancel={() => {
                this.setState({ warningInfo: false });
              }}
              content={this.state.warningInfoText}
              tipsObj={this.state.warningInfoObj}
              cancelBtnHandle={() => {
                this.setState({ warningInfo: false });
              }}
              hasDownload
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  work: state.work.work,
  files: state.files.files,
  currFile: state.files.currFile,
  processPercent: state.work.processPercent,
  tokenId: state.common.tokenId,
  preUploadFile: state.files.preUploadFile,
  uploading: state.work.uploading,
  uploadPercent: state.work.uploadPercent,
  processStep: state.work.processStep,
  startTime: state.work.startTime,
  fileToBlobStatus: state.work.fileToBlobStatus,
  submitting: state.work.submitting,
  uploadAgainFile: state.files.uploadAgainFile,
  crop: state.work.crop,
  authorization: state.common.authorization,
  subscription: state.common.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  onFilesChange: (files) => dispatch(actions.onFilesChange(files)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onUploadingChange: (uploading) =>
    dispatch(actions.onUploadingChange(uploading)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onStartTimeChange: (startTime) =>
    dispatch(actions.onStartTimeChange(startTime)),
  onPreUploadFileChange: (preUploadFile) =>
    dispatch(actions.onPreUploadFileChange(preUploadFile)),
  onCurrFileChange: (currFile) => dispatch(actions.onCurrFileChange(currFile)),
  onFileToBlobStatusChange: (fileToBlobStatus) =>
    dispatch(actions.onFileToBlobStatusChange(fileToBlobStatus)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onCropChange: (crop) => dispatch(actions.onCropChange(crop)),
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
  advertiseConfig: (advertiseConfig) =>
    dispatch(actions.advertiseConfig(advertiseConfig)),
  openAdvertiseDialog: (visible) =>
    dispatch(actions.openAdvertiseDialog(visible)),
  onExceed2M: (visible) => dispatch(actions.onExceed2M(visible)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['common'])(AddFileByDrag));
